import { forwardRef } from 'react';
import { Input } from './input';

interface NumberInputProps extends Omit<
    React.ComponentProps<typeof Input>,
    'type' | 'onChange' | 'value'
> {
    value: number | '';
    onChange: (value: number | '') => void;
}

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
    ({ value, onChange, ...props }, ref) => (
        <Input
            ref={ref}
            type="number"
            value={value}
            onChange={(e) =>
                onChange(e.target.value === '' ? '' : Number(e.target.value))
            }
            {...props}
        />
    )
);
NumberInput.displayName = 'NumberInput';

export default NumberInput;
